export default __webpack_public_path__ + "static/media/tworzenie-eventu-2.840ec040.png";